export default {
  MANUAL: "manual",
};
